"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGameStream = void 0;
const flatbuffers = require("flatbuffers");
class IGameStream {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsIGameStream(bb, obj) {
        return (obj || new IGameStream()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsIGameStream(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new IGameStream()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    controls() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    fixedSize() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    fullscreen() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    streamType(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    description(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    playerWidth() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    streamWidth() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    playerHeight() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    streamHeight() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    geoCountryAllow(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    geoCountryBlock(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    audioBitRateKbps() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    streamStretching(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    uniqueStreamName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 30);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    videoBitRateKbps() {
        const offset = this.bb.__offset(this.bb_pos, 32);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    static startIGameStream(builder) {
        builder.startObject(15);
    }
    static addControls(builder, controls) {
        builder.addFieldInt8(0, +controls, +false);
    }
    static addFixedSize(builder, fixedSize) {
        builder.addFieldInt8(1, +fixedSize, +false);
    }
    static addFullscreen(builder, fullscreen) {
        builder.addFieldInt8(2, +fullscreen, +false);
    }
    static addStreamType(builder, streamTypeOffset) {
        builder.addFieldOffset(3, streamTypeOffset, 0);
    }
    static addDescription(builder, descriptionOffset) {
        builder.addFieldOffset(4, descriptionOffset, 0);
    }
    static addPlayerWidth(builder, playerWidth) {
        builder.addFieldInt16(5, playerWidth, 0);
    }
    static addStreamWidth(builder, streamWidth) {
        builder.addFieldInt8(6, streamWidth, 0);
    }
    static addPlayerHeight(builder, playerHeight) {
        builder.addFieldInt16(7, playerHeight, 0);
    }
    static addStreamHeight(builder, streamHeight) {
        builder.addFieldInt8(8, streamHeight, 0);
    }
    static addGeoCountryAllow(builder, geoCountryAllowOffset) {
        builder.addFieldOffset(9, geoCountryAllowOffset, 0);
    }
    static addGeoCountryBlock(builder, geoCountryBlockOffset) {
        builder.addFieldOffset(10, geoCountryBlockOffset, 0);
    }
    static addAudioBitRateKbps(builder, audioBitRateKbps) {
        builder.addFieldInt8(11, audioBitRateKbps, 0);
    }
    static addStreamStretching(builder, streamStretchingOffset) {
        builder.addFieldOffset(12, streamStretchingOffset, 0);
    }
    static addUniqueStreamName(builder, uniqueStreamNameOffset) {
        builder.addFieldOffset(13, uniqueStreamNameOffset, 0);
    }
    static addVideoBitRateKbps(builder, videoBitRateKbps) {
        builder.addFieldInt8(14, videoBitRateKbps, 0);
    }
    static endIGameStream(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createIGameStream(builder, controls, fixedSize, fullscreen, streamTypeOffset, descriptionOffset, playerWidth, streamWidth, playerHeight, streamHeight, geoCountryAllowOffset, geoCountryBlockOffset, audioBitRateKbps, streamStretchingOffset, uniqueStreamNameOffset, videoBitRateKbps) {
        IGameStream.startIGameStream(builder);
        IGameStream.addControls(builder, controls);
        IGameStream.addFixedSize(builder, fixedSize);
        IGameStream.addFullscreen(builder, fullscreen);
        IGameStream.addStreamType(builder, streamTypeOffset);
        IGameStream.addDescription(builder, descriptionOffset);
        IGameStream.addPlayerWidth(builder, playerWidth);
        IGameStream.addStreamWidth(builder, streamWidth);
        IGameStream.addPlayerHeight(builder, playerHeight);
        IGameStream.addStreamHeight(builder, streamHeight);
        IGameStream.addGeoCountryAllow(builder, geoCountryAllowOffset);
        IGameStream.addGeoCountryBlock(builder, geoCountryBlockOffset);
        IGameStream.addAudioBitRateKbps(builder, audioBitRateKbps);
        IGameStream.addStreamStretching(builder, streamStretchingOffset);
        IGameStream.addUniqueStreamName(builder, uniqueStreamNameOffset);
        IGameStream.addVideoBitRateKbps(builder, videoBitRateKbps);
        return IGameStream.endIGameStream(builder);
    }
}
exports.IGameStream = IGameStream;
